import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

import { Typography, Text, IconLink, rem } from '@blueprint/ui';

import { Paragraph } from 'components/Reply/Paragraph';
import { colors } from 'themes';

const { black } = colors;

const createHeadingComponent =
  (headingLevel) =>
  ({ children }) => (
    <Typography variant={headingLevel} lineHeight={1.31} color={black}>
      {children}
    </Typography>
  );

export const BlueprintMarkdown = ({ markdown }) => {
  return (
    <Markdown
      remarkPlugins={[remarkGfm, remarkBreaks]}
      components={{
        p: ({ children }) => {
          return <Paragraph>{children}</Paragraph>;
        },
        a: ({ children, ...rest }) => {
          return (
            <IconLink
              {...rest}
              underline
              icon="NewWindow"
              direction="right"
              iconProps={{
                titleAccess: '(open in new window)',
                size: rem(16),
                width: rem(16),
                height: rem(16),
                marginLeft: rem(4),
              }}
              target="_blank"
              rel="noreferrer"
            >
              {children}
            </IconLink>
          );
        },
        strong: ({ children }) => {
          return (
            <Text as="strong" fontWeight="bold">
              {children}
            </Text>
          );
        },
        h1: createHeadingComponent('h1'),
        h2: createHeadingComponent('h2'),
        h3: createHeadingComponent('h3'),
        h4: createHeadingComponent('h4'),
        h5: createHeadingComponent('h5'),
        h6: createHeadingComponent('h6'),
      }}
    >
      {markdown}
    </Markdown>
  );
};
